import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

interface DroppableContainerProps {
  id: string;
  children: React.ReactNode;
}

const DroppableContainer: React.FC<DroppableContainerProps> = ({ id, children }) => {
  const { t } = useTranslation();

  const { setNodeRef } = useDroppable({
    id,
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  // @ts-ignore
  const hasNoItems = children.props.items.length === 0;

  return (
    <Grid
      sx={{
        border: isSmallScreen ? 0 : '1px solid',
        borderColor: 'divider',
        p: isSmallScreen ? 0 : 2,
        borderRadius: '8px',
      }}
      container
      flexDirection="column"
      ref={setNodeRef}
      minHeight="150px">
      {hasNoItems ? (
        <Grid container height="100%" justifyContent="center" alignItems="center" gap={1}>
          <AddCircleOutline color="primary" sx={{ height: '32px', width: '32px' }} />
          <Typography variant="h6">{t('emailTemplates.dndhere')}</Typography>
        </Grid>
      ) : (
        children
      )}
    </Grid>
  );
};

export default DroppableContainer;
